<template>
  <main data-preview-id="">
    <div class="content-container-outer">
      <div class="content-container">
        <div class="kb-breadcrumbs">
          <div class="kb-breadcrumbs__mobile-back">
            <svg
              class="kb-breadcrumbs__arrow kb-breadcrumbs__arrow--left"
              width="7"
              height="12"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M.055 5.7194c.018-.045.0518-.0835.0795-.125.0166-.0255.0322-.052.0489-.0775.007-.011.0116-.024.0216-.034L5.2426.2328c.2877-.3.7662-.3115 1.0685-.026a.7468.7468 0 0 1 .0262 1.0605L1.7954 6l4.5419 4.733a.7462.7462 0 0 1-.0262 1.0601.7563.7563 0 0 1-.5214.207.7568.7568 0 0 1-.547-.2325L.205 6.5174c-.01-.0105-.0146-.023-.0216-.0345-.0167-.025-.0323-.0515-.0489-.077-.0277-.0415-.0615-.08-.0796-.125-.0186-.0455-.0222-.0935-.0312-.141C.0147 6.0934 0 6.0474 0 5.9999c0-.047.0146-.093.0237-.1395.009-.0475.0126-.096.0312-.141"
                fill="#7C98B6"
                fill-rule="evenodd"
              />
            </svg>
            <a href="/qa">ホームに戻る</a>
          </div>
          <ol
            itemscope=""
            itemtype="http://schema.org/BreadcrumbList"
          >
            <li
              itemprop="itemListElement"
              itemscope=""
              itemtype="http://schema.org/ListItem"
            >
              <a
                itemprop="item"
                href="/qa"
              >
                <span itemprop="name">サポートトップ</span>
              </a>
              <meta
                itemprop="position"
                content="1"
              >
            </li>
          </ol>
        </div>
        <div class="main-body">
          <Sidebar />
          <div class="kb-content">
            <div class="kb-search-results">
              <div
                id="mytemplate"
                class="kb-search-results__template"
                style="display: none;"
              >
                <li>
                  <a
                    href=""
                    class="kb-search-results__title"
                  />
                  <div class="kb-search__result__breadcrumb kb__text-link">
                    <span class="kb-search-results__cat" />
                    <span class="kb-search-results__subcat">
                      <svg
                        class="kb-breadcrumbs__arrow kb-breadcrumbs__arrow--right"
                        width="7"
                        height="12"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.4905 5.7194c-.018-.045-.0518-.0835-.0795-.125-.0167-.0255-.0323-.052-.049-.0775-.007-.011-.0115-.024-.0216-.034L1.3028.2328c-.2876-.3-.7662-.3115-1.0684-.026a.7468.7468 0 0 0-.0262 1.0605L4.75 6l-4.542 4.733a.7462.7462 0 0 0 .0263 1.0601.7563.7563 0 0 0 .5213.207.7568.7568 0 0 0 .5471-.2325l5.0376-5.2501c.0101-.0105.0146-.023.0217-.0345.0166-.025.0322-.0515.0489-.077.0277-.0415.0614-.08.0795-.125.0187-.0455.0222-.0935.0313-.141.009-.0465.0237-.0925.0237-.14 0-.047-.0147-.093-.0237-.1395-.009-.0475-.0126-.096-.0313-.141"
                          fill="#7C98B6"
                          fill-rule="evenodd"
                        />
                      </svg>
                      <span class="kb-search-results__subcat-text" />
                    </span>
                  </div>
                  <div class="kb-search-results__description" />
                </li>
              </div>
              <h1
                class="kb-search-results__heading"
                data-lang-no-results="「video」の結果はありません"
                data-lang-with-results="「video」の結果"
              >
                「{{ keyword }}」の結果
              </h1>
              <ul
                v-if="faqPostList.length > 0"
                id="hsresults"
                class="kb-search-results__listing"
                data-lang-heading="申し訳ありません。「video」の検索結果はありません。"
                data-lang-message="文言を変えてみるか、ナレッジ記事を参照してください。"
                data-lang-tip="まだ答えが見つからない場合は、サポートチームにご連絡ください。"
              >
                <li
                  v-for="post in faqPostList"
                  :key="post.id"
                >
                  <a
                    class="kb-search-results__title"
                    :href="`/qa/faq/${post.id}`"
                  >
                    <span class="hs-search-highlight hs-highlight-title">{{ post.title }}</span>
                  </a>
                  <div class="kb-search__result__breadcrumb kb__text-link">
                    <span
                      v-show="post.parent_category_name"
                      class="kb-search-results__cat"
                    >{{ post.parent_category_name }}</span>
                    <span
                      class="kb-search-results__subcat"
                    >
                      <svg
                        v-show="post.parent_category_name"
                        xmlns="http://www.w3.org/2000/svg"
                        height="12"
                        width="7"
                        class="kb-breadcrumbs__arrow kb-breadcrumbs__arrow--right"
                      >
                        <path
                          fill-rule="evenodd"
                          fill="#7C98B6"
                          d="M6.4905 5.7194c-.018-.045-.0518-.0835-.0795-.125-.0167-.0255-.0323-.052-.049-.0775-.007-.011-.0115-.024-.0216-.034L1.3028.2328c-.2876-.3-.7662-.3115-1.0684-.026a.7468.7468 0 0 0-.0262 1.0605L4.75 6l-4.542 4.733a.7462.7462 0 0 0 .0263 1.0601.7563.7563 0 0 0 .5213.207.7568.7568 0 0 0 .5471-.2325l5.0376-5.2501c.0101-.0105.0146-.023.0217-.0345.0166-.025.0322-.0515.0489-.077.0277-.0415.0614-.08.0795-.125.0187-.0455.0222-.0935.0313-.141.009-.0465.0237-.0925.0237-.14 0-.047-.0147-.093-.0237-.1395-.009-.0475-.0126-.096-.0313-.141"
                        />
                      </svg>
                      <span class="kb-search-results__subcat-text">{{ post.category_name }}</span>
                    </span>
                  </div>
                  <div class="kb-search-results__description" />
                </li>
              </ul>
              <ul
                v-else
                class="kb-search-results__listing"
              >
                <p>申し訳ありません。「{{ keyword }}」の検索結果はありません。</p>
                <p>文言を変えてみるか、ナレッジ記事を参照してください。</p>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import axios from '@axios'
import Sidebar from '../components/Sidebar.vue'

export default {
  name: 'SearchPage',
  components: {
    Sidebar
  },
  data() {
    return {
      title: '',
      faq_posts: [],
      keyword: ''
    }
  },
  computed: {
    faqPostList() {
      return this.faq_posts.map((post) => {
        return {
          id: post.id,
          title: post.title,
          description: post.description,
          category_name: post.category_name,
          parent_category_name: post.parent_category_name
        }
      })
    }

  },
  mounted() {
    this.title = 'FAQ'
    this.keyword = this.$route.query.keyword
    this.fetchFaqPostList(this.keyword)

  },
  methods: {
    async fetchFaqPostList(keyword) {
      try {
        const { data } = await axios.get('/api/v2/faq_posts', {
          params: {
            keyword: keyword
          }
        })
        this.faq_posts = data.faq_posts
      } catch (error) {
        //
      }
    },
  },


}
</script>

<style lang="scss" scoped></style>
